import axios from 'axios';

const BASE_URL_CREDIT_CARD_EXPIRED_TRIGGER = '/app/creditCardExpiredTrigger';

export const createOrUpdateCreditCardExpiredConfig = async (oracleId, daysBeforeExpiration) => {
    const payload = {
        daysBeforeExpiration,
        oracleId,
    };

    const { data } = await axios.post(`${BASE_URL_CREDIT_CARD_EXPIRED_TRIGGER}`, payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return data;
};

export const getCreditCardExpiredConfig = async (oracleId) => {
    const { data } = await axios.get(`${BASE_URL_CREDIT_CARD_EXPIRED_TRIGGER}/${oracleId}`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });

    return data;
};
